<template>
  <tabs />
  <div class="main-area h-full">
    <div class="mx-12">
      <ControlledCompanyTourMap
        v-if="showMap"
        :auto-center="true"
        :lazy="false"
        :has-embedded-date-range="true"
        :company="modelValue"
        :useBounds="false"
        :filter="filter"
        :initial-zoom="9"
        :date-range-restriction="dateRange"
        />
      <div v-else class="flex flex-col items-center justify-center h-full text-xl">
          {{$t('tourMap.error_license')}}
      </div>
    </div>
  </div>
</template>

<script lang="tsx" setup>
import { computed, inject, ref } from 'vue';
import Tabs from '@components/structure/navigation/Tabs.vue';
import type { Company } from '@/entities/Entities';
import ControlledCompanyTourMap from '@components/utils/maps/ControlledCompanyTourMap.vue';
import globalLicenseFilterKey from '@/components/utils/globalLicenseFilter/injects';
import type { Filter } from '@/components/utils/table/hooks/provider';
import { useRoute } from 'vue-router';

interface Props {
  modelValue: Company;
}

const props = defineProps<Props>();

const route = useRoute();

const globalFilter = inject(globalLicenseFilterKey)!
const filter = computed<Filter>(() => {
  const f:Filter = {
    'exists[license]': true,
  };

  if(globalFilter.value?.licenseId) {
    f['license'] = globalFilter.value.licenseId;
  }

  if(globalFilter.value?.boxType) {
    f['tour_license_seat_type'] = globalFilter.value.boxType;
  }

  return f;
});
const showMap = computed(() => !!globalFilter.value?.licenseId);

const endDate = new Date();
const startDate = new Date();
startDate.setMonth(startDate.getMonth() - 3);
const dateRange = {
  start: startDate,
  end: endDate,
};

</script>

<style lang="scss" scoped>
button {
  @apply block;
}

.table {
  @apply flex flex-col;
}
</style>
